export const calculateTotals = (a,b) => {
  const calc = a + b;
  return Number((calc).toFixed(2));
}

export const calculateSavings = (received,waisted) => {
  const calc = received - waisted;
  return Number((calc).toFixed(2));
}